import React from "react";
import { Tooltip } from "antd";
import { MessageCircle, X, File } from "lucide-react";
import { PinnedMessage } from "../../types/chat";
import styles from "./PinnedMessages.module.scss";

interface PinnedMessageItemProps {
  message: PinnedMessage;
  onUnpin: (messageId: string) => void;
  onScrollTo: (messageId: string) => void;
  onCollapse: () => void;
}

export const PinnedMessageItem: React.FC<PinnedMessageItemProps> = ({ message, onUnpin, onScrollTo, onCollapse }) => {
  const handleClick = () => {
    onScrollTo(message.MessageId);
    onCollapse();
  };

  const handleUnpinClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log("check message data", message);

    onUnpin(message.MessageId);
  };

  const truncateText = (text: string, maxLength: number = 100) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const renderMessageContent = () => {
    switch (message.Type) {
      case "Image":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {message.ThumbUrl && <img src={message.ThumbUrl} alt="" className={styles.imagePreview} />}
            <span className={styles.message}>[Hình ảnh]</span>
          </div>
        );
      case "Video":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {message.ThumbUrl && <img src={message.ThumbUrl} alt="" className={styles.imagePreview} />}
            <span className={styles.message}>[Video]</span>
          </div>
        );
      case "File":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <File size={16} color="#fff" />
            <span className={styles.message}>[File] - {truncateText(message.Message)}</span>
          </div>
        );
      default:
        return <div className={styles.message}>{truncateText(message.Message)}</div>;
    }
  };

  return (
    <div className={styles.item} onClick={handleClick}>
      <MessageCircle className={styles.icon} size={18} />
      <div className={styles.content}>
        <div className={styles.creator}>{message.Creator}</div>
        {renderMessageContent()}
      </div>
      <Tooltip title="Bỏ ghim" placement="left">
        <X className={styles.unpinButton} size={16} onClick={handleUnpinClick} />
      </Tooltip>
    </div>
  );
};
